export class Menu {
  id: string;
  display_name: string;
  name: string;
  icon: string;
  url: string;
  parent: number;
  menu_order: number;
  menu_action: Array<boolean>;
  /*
     misal:
      add   edit  delete
     [true, false, true]
     berarti bisa melakukan action add, delete, tapi tidak bisa edit
    */
  menu_child: Array<Menu>;
}

export class TicketingSubmenu {
  alltickets: Array<boolean>;
  // "add",
  // "edit",
  // "delete"
  // kayaknya bagusan true,true,true gitu
  mytickets: Array<boolean>;
  monitoring: Array<boolean>;
}

export class UserManagementSubmenu {
  administrator: Array<boolean>;
  client: Array<boolean>;
  userLevel: Array<boolean>;
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/_shared/models/menu.ts